import React, { Dispatch, SetStateAction } from "react";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import moment, { Moment } from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";

interface PredefinedDateRangesProps {
  state: { start: Moment | undefined; end: Moment | undefined };
  setState: Dispatch<
    SetStateAction<{ start: Moment | undefined; end: Moment | undefined }>
  >;
}

const PredefinedDateRanges: React.FC<PredefinedDateRangesProps> = ({
  state,
  setState,
}) => {
  const { start, end } = state;

  const handleCallback = (start: moment.Moment, end: moment.Moment) => {
    setState({ start, end });
  };

  // Format label or show placeholder if dates are undefined
  const label =
    start && end
      ? `${start.format("MM/DD/YYYY")} - ${end.format("MM/DD/YYYY")}`
      : "Select a date range";

  return (
    <DateRangePicker
      initialSettings={{
        startDate: start ? start.toDate() : undefined,
        endDate: end ? end.toDate() : undefined,
        ranges: {
          Today: [moment().toDate(), moment().toDate()],
          Yesterday: [
            moment().subtract(1, "days").toDate(),
            moment().subtract(1, "days").toDate(),
          ],
          "Last 7 Days": [
            moment().subtract(6, "days").toDate(),
            moment().toDate(),
          ],
          "Last 30 Days": [
            moment().subtract(29, "days").toDate(),
            moment().toDate(),
          ],
          "This Month": [
            moment().startOf("month").toDate(),
            moment().endOf("month").toDate(),
          ],
          "Last Month": [
            moment().subtract(1, "month").startOf("month").toDate(),
            moment().subtract(1, "month").endOf("month").toDate(),
          ],
        },
      }}
      onCallback={handleCallback}
    >
      <div id="reportrange daterangepicker" className="new-date">
        <span>{label}</span>
      </div>
    </DateRangePicker>
  );
};

export default PredefinedDateRanges;
